import { Listener } from '../listenersStore';

const selectionLevelListeners: Listener = {
  'refresh/selection-levels': (dispatch: any, action: any) => {
    dispatch({
      type: 'APPLICATION_SELECTION_LEVEL_FETCH_START',
      payload: action.payload,
    });
  },
};

export default selectionLevelListeners;
